import { TLanguage } from '@lib/core/retailers/types';
import MixpanelTracker from '@lib/tools/dat/mixpanel';

import { FidelityDetachButton } from '@components/web/src/atoms/Buttons/FidelityDetachButton/FidelityDetachButton';
import * as S from '@components/web/src/atoms/Headers/HeaderKiosk/styles';
import { VinhoodLogo } from '@components/web/src/atoms/VinhoodLogo/VinhoodLogo';
import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { LanguageSwitcher } from '@components/web/src/organisms/LanguageSwitcher/LanguageSwitcher';

interface Props {
  isShowLanguageSwitcher: boolean;
  isShowDetachFidelityCard?: boolean;
  retailerLanguages: TLanguage[];
  locale: string;
  handleLogoClick: () => void;
  handleDetachButtonClick: () => void;
}

export const HeaderKiosk = ({
  isShowLanguageSwitcher,
  isShowDetachFidelityCard,
  retailerLanguages,
  locale,
  handleLogoClick,
  handleDetachButtonClick,
}: Props) => {
  return (
    <S.HeaderKioskContainer align="center" justify="space-between" padding="0 32px">
      <S.LogoWrapper onClick={handleLogoClick}>
        <VinhoodLogo isLargeVariant />
      </S.LogoWrapper>
      <Flexbox align="center" gap={24}>
        {isShowDetachFidelityCard && (
          <FidelityDetachButton
            onClick={() => {
              handleDetachButtonClick();
              MixpanelTracker.events.detachFidelityCard();
            }}
          />
        )}
        {isShowLanguageSwitcher && (
          <LanguageSwitcher languageSwitcherType="icon" locale={locale} retailerLanguages={retailerLanguages} />
        )}
      </Flexbox>
    </S.HeaderKioskContainer>
  );
};
